import React from 'react';
import Image from '../Global/Image';
import {Link} from 'react-router-dom';
import styles from './Article.module.scss';
import Button from '../Global/Button';

export default function Article({item, big = false}) {
    const src = require(`../../images/articles/${item.slug}.jpg`);
    const srcRet = require(`../../images/articles/${item.slug}@2x.jpg`);
    const webp = require(`../../images/articles/${item.slug}.webp`);
    const webpRet = require(`../../images/articles/${item.slug}@2x.webp`);
    return (
        <article key={item} className={[styles.Main, big ? styles.Big : null].join(' ')} data-slug={item.slug}>
            <Link to={`/evenement/${item.slug}`} className={styles.Figure}>
                <Image {...{src, srcRet, webp, webpRet}}/>
            </Link>

            <div className={styles.ArticleContent}>
                <Link to={`/evenement/${item.slug}`}>
                    <h2 dangerouslySetInnerHTML={{__html: item.title}}/>
                </Link>

                <Link to={`/evenement/${item.slug}`}>
                    <p dangerouslySetInnerHTML={{__html: item.description}}/>
                </Link>

                <Button url={`/evenement/${item.slug}`} text={`En savoir plus`} external={false}/>
            </div>
        </article>
    );
}